import { render, staticRenderFns } from "./Approach.vue?vue&type=template&id=b0760bf2&scoped=true"
import script from "./Approach.vue?vue&type=script&lang=js"
export * from "./Approach.vue?vue&type=script&lang=js"
import style0 from "./Approach.vue?vue&type=style&index=0&id=b0760bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0760bf2",
  null
  
)

export default component.exports